import CONSTANTS from './CONSTANTS';

export const selectedLanguage = () => {
  let language;

  if (CONSTANTS.language === 'en') {
    language = CONSTANTS.stroop.coloursEnglish;
  } else if (CONSTANTS.language === 'nl') {
    language = CONSTANTS.stroop.coloursDutch;
  } else if (CONSTANTS.language === 'de') {
    language = CONSTANTS.stroop.coloursGerman;
  } else {
    language = CONSTANTS.stroop.coloursEnglish;
  }

  return language;
};
